var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonalManage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "31_\u4E2A\u4EBA\u7BA1\u7406") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32,36a16,16,0,1,0-8.38-2.39C14.51,37.29,8,46.82,8,58a2,2,0,0,0,4,0c0-12,8.82-21.83,19.72-22ZM20,20A12,12,0,1,1,32.15,32h-.43A12,12,0,0,1,20,20Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.66,43.14a2,2,0,0,0-2.83-2.83l-4.24,4.24a1.79,1.79,0,0,0-.25.31,1.19,1.19,0,0,0-.09.15c0,.07-.07.13-.1.19l-.06.21a.84.84,0,0,0-.05.17,2,2,0,0,0,0,.78,1.09,1.09,0,0,0,.05.17l.06.2c0,.07.07.13.1.19a1.29,1.29,0,0,0,.09.16,1.42,1.42,0,0,0,.25.3h0a1.76,1.76,0,0,0,.3.24l.16.09.18.09.21.07.17,0A2.58,2.58,0,0,0,34,48H54a2,2,0,0,0,0-4H38.83Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54,52H34a2,2,0,0,0,0,4H49.37l-1,1a2,2,0,0,0,2.83,2.83l4.24-4.24A2,2,0,0,0,56,54.09s0-.07,0-.1A2,2,0,0,0,54,52Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalManage);
export default __webpack_public_path__ + "static/media/personalManage.2406bab1.svg";
export { ForwardRef as ReactComponent };